import { Component, OnInit } from '@angular/core';

import { PagerService } from '../services/pager.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ModalService } from '../shared/modal/modal.service';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css']
})
export class LeadsComponent implements OnInit {

  public leads: any;
  public advisor: any;
  public organization: any;
  public error: any;
  public advisorCode: any;

  public advisors: any;

  public role: number;

  constructor(private globalService: GlobalService, private modalService: ModalService) {
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'assign-leadClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        // this.getClient();
        // this.magiVal = 100;
        // this.animateValue(this.totalSurchargeSavingsEl, 0, this.roundAndFormat(0, 0));
        this.getLeads();
        // console.log('reset to defaults');
      }
      // console.log(modal.modalName);
    });

    this.getAdvisorData(); 
  }

  getAdvisorData() {
    this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
      .subscribe(
        advisor => { 
          this.advisor = advisor;
          this.getOrganizationData(advisor.OrganizationID);
          // this.getConsumerToolLink(this.advisor);
          // console.log(this.advisor);
        },
        error => this.error = <any>error);
  }

  getOrganizationData(orgId) {
    this.globalService.getOrganizationData(orgId)
      .subscribe(
        organization => { 
          this.organization = organization;
          this.getConsumerToolLink(this.organization);
        },
        error => this.error = <any>error);
  }

  getConsumerToolLink(organization) {
    var OrganizationModel = {
      // UserID: 935,
      OrganizationID: organization.ID,
    }

    // console.log(organization)

    this.globalService.consumerTools(OrganizationModel)
      .subscribe(
        link => { 
          // console.log(link);
          this.advisorCode = link.replace(/'/g, '"');
        },
        error => this.error = <any>error);
  }

  public visible: boolean = false;

  ngOnInit() {

    this.role = Number(localStorage.getItem('roleId'));

    this.visible = (Number(localStorage.getItem('userId')) === 5425 || Number(localStorage.getItem('userId')) === 5492)  ? false : true;
    
    this.getLeads();
    if(this.role < 3){
      this.getAdvisors();
    }
  }

  viewLead(lead) {
    this.getLeadInfo(lead);
  }

  assignLead(leadRelationshipId) {
    this.modalService.add('assign-lead', { advisors: this.advisors, leadRelationshipId: leadRelationshipId });
  }

  archiveLead(lead) {
    this.globalService.archiveLead(lead.leadRelationshipId)
    .subscribe(
    resp => {
      this.getLeads();
    },
    error => this.error = <any>error);
  }

  getAdvisors() {
    this.globalService.getAdvisorsData()
      .subscribe(
      advisors => {
        this.advisors = advisors;
      },
      error => this.error = <any>error);
  }

  getLeads() {
    this.globalService.getUserLeads()
      .subscribe(
      leads => {
        this.leads = leads;
      },
      error => this.error = <any>error);
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  }

  getUnassignedLeads() {
    this.globalService.getUnassignedLeads()
      .subscribe(
      leads => {
        // console.log(leads);
      },
      error => this.error = <any>error);
  }

  getLeadInfo(lead) {
    this.globalService.getLeadInfo(lead.leadRelationshipId)
      .subscribe(
      leadDetails => {
        
        for(var key in leadDetails) {
          lead[leadDetails[key].Key] = leadDetails[key].Value;
        }

        this.modalService.add('view-lead', lead);
      },
      error => this.error = <any>error);
  }

  filterItem() {
    
  }
}
